import { apiAdd, apiGet, apiUpdate } from "../../API/Service/apiClient";

 
export const handleAE_categorySubForm = async({
  setLoading,data,showAlert,resetForm,
  navigate})=>{      
  let id= data.get("id") || 0;  
  setLoading(true)
  
  try {
    let resData={};
    if(id > 0){     
      resData =await apiUpdate("catg-data",data,{contentType:"multipart/form-data"});         
    }else{
      resData =await apiAdd("catg-data",data,{contentType:"multipart/form-data"});        
    }
    if(resData?.data === -1){            
      showAlert({
        title: "Error?",
        message: "This category/sub-category is already registered with us.",
        type: "error",
        confirmLabel: "Ok",
        cancelLabel: "Cancel",    
        showCancel: false,      
      });
    }
    else if(resData?.data > 0){
      showAlert({
        title: "Success",
        message: "Record saved successfully",
        type: "success",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,   
        onConfirm: () => {                       
          resetForm();         
          navigate('/admin/catg-sub-list')           
        },      
      });

    }else{
      showAlert({
        title: "Error?",
        message: "Oops! Something went wrong. Please try again later.",
        type: "error",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,         
      });
    }
    
  } catch (error) {
    // console.log(error);
     
  }finally{
    setLoading(false)
  }
}

export const handleGet_categorySubForm = async ({
  filter,
  setDataList,
  showAlert,   
}) => {  
  try {
    const resData = await apiGet("catg-data", filter || {});
    setDataList(resData?.data)
    
  } catch (err) {
    // showAlert({
    //   title: "Error",
    //   message: err?.message || "Something went wrong. Please try again.",
    //   type: "error",
    //   confirmLabel: "Ok",
    // });
  } finally {
    
  }
};